module.exports = __FOREMAN_VENDOR__SEAMLESS_IMMUTABLE__;